/* eslint-disable jsx-a11y/anchor-is-valid */
import './App.css';
import { ChromePicker } from 'react-color'
import { useState } from 'react';
import ReactGA from "react-ga4";

function App() {

  ReactGA.initialize("G-DBDD5EWFEY");

  function generateFinalCSS() {
    ReactGA.event("download_button_click");

    var finalCSS = `b,h1,h2,h3,h4,h5,h6,legend,strong,th{font-weight:600}table,textarea:not([cols]){width:100%}table caption,td,th{text-align:left}input,td,th{vertical-align:top}body,td,th{word-wrap:break-word}code,kbd,samp,time{background:#efefef}details[open] summary,table{margin-bottom:10px}button,input[type=button],input[type=checkbox],input[type=radio],input[type=range],input[type=reset],input[type=submit],select,summary{cursor:pointer}input[type=range]:focus,summary{outline:0}details,dialog{background-color:#f7f7f7}body,dialog,kbd{color:#363636}:root{--background-body:${backgroundBody};--background:${background};--background-alt:#f7f7f7;--selection:${selection};--text-main:${textMain};--text-bright:${textBright};--text-muted:#70777f;--links:${link};--focus:${focus};--border:${border};--code:#000;--animation-duration:0.1s;--button-base:${button};--button-hover:${buttonHover};--scrollbar-thumb:${scrollbar};--scrollbar-thumb-hover:var(--button-hover);--form-placeholder:#949494;--form-text:${textForm};--variable:#39a33c;--highlight:#ff0;--select-arrow:url("data:image/svg+xml;charset=utf-8,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' height='62.5' width='116.9' fill='%23161f27'%3E %3Cpath d='M115.3,1.6 C113.7,0 111.1,0 109.5,1.6 L58.5,52.7 L7.4,1.6 C5.8,0 3.2,0 1.6,1.6 C0,3.2 0,5.8 1.6,7.4 L55.5,61.3 C56.3,62.1 57.3,62.5 58.4,62.5 C59.4,62.5 60.5,62.1 61.3,61.3 L115.2,7.4 C116.9,5.8 116.9,3.2 115.3,1.6Z'/%3E %3C/svg%3E")}html{scrollbar-color:rgb(170,170,170) #fff;scrollbar-color:var(--scrollbar-thumb) var(--background-body);scrollbar-width:thin}body{font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue','Segoe UI Emoji','Apple Color Emoji','Noto Color Emoji',sans-serif;line-height:1.4;max-width:800px;margin:20px auto;padding:0 10px;color:var(--text-main);background:#fff;background:var(--background-body);text-rendering:optimizeLegibility}button,input,textarea{transition:background-color .1s linear,border-color .1s linear,color .1s linear,box-shadow .1s linear,transform .1s;transition:background-color var(--animation-duration) linear,border-color var(--animation-duration) linear,color var(--animation-duration) linear,box-shadow var(--animation-duration) linear,transform var(--animation-duration) ease}h1{font-size:2.2em}h1,h2,h3,h4,h5,h6{margin-bottom:12px;margin-top:24px}h1,h2,h3,h4,h5,h6,strong{color:#000;color:var(--text-bright)}q::after,q::before{content:none}blockquote,q{border-left:4px solid #0096bfab;border-left:4px solid var(--focus);margin:1.5em 0;padding:.5em 1em;font-style:italic}address,blockquote cite,blockquote>footer,var{font-style:normal}blockquote>footer{border:0}a[href^='mailto\\:']::before{content:'📧 '}a[href^='tel\\:']::before{content:'📞 '}a[href^='sms\\:']::before{content:'💬 '}mark{background-color:#ff0;background-color:var(--highlight);border-radius:2px;padding:0 2px;color:#000}a>code,a>strong{color:inherit}input,select{display:block}[type=checkbox],[type=radio]{display:initial}button,input,select,textarea{color:#1d1d1d;color:var(--form-text);background-color:#efefef;background-color:var(--background);font-family:inherit;font-size:inherit;margin-right:6px;margin-bottom:6px;padding:10px;border:none;border-radius:6px;outline:0}button,input[type=button],input[type=reset],input[type=submit]{background-color:#d0cfcf;background-color:var(--button-base);padding-right:30px;padding-left:30px}button:hover,input[type=button]:hover,input[type=reset]:hover,input[type=submit]:hover{background:#9b9b9b;background:var(--button-hover)}input[type=color]{min-height:2rem;padding:8px;cursor:pointer}input[type=checkbox],input[type=radio]{height:1em;width:1em}input[type=radio]{border-radius:100%}label{vertical-align:middle;margin-bottom:4px;display:inline-block}button,input:not([type=checkbox]):not([type=radio]),input[type=range],select,textarea{-webkit-appearance:none}textarea{display:block;margin-right:0;box-sizing:border-box;resize:vertical}textarea:not([rows]){min-height:40px;height:140px}select{background:url("data:image/svg+xml;charset=utf-8,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' height='62.5' width='116.9' fill='%23161f27'%3E %3Cpath d='M115.3,1.6 C113.7,0 111.1,0 109.5,1.6 L58.5,52.7 L7.4,1.6 C5.8,0 3.2,0 1.6,1.6 C0,3.2 0,5.8 1.6,7.4 L55.5,61.3 C56.3,62.1 57.3,62.5 58.4,62.5 C59.4,62.5 60.5,62.1 61.3,61.3 L115.2,7.4 C116.9,5.8 116.9,3.2 115.3,1.6Z'/%3E %3C/svg%3E") calc(100% - 12px) 50%/12px no-repeat #efefef;background:var(--background) var(--select-arrow) calc(100% - 12px) 50%/12px no-repeat;padding-right:35px}select::-ms-expand{display:none}select[multiple]{padding-right:10px;background-image:none;overflow-y:auto}button:focus,input:focus,select:focus,textarea:focus{box-shadow:0 0 0 2px #0096bfab;box-shadow:0 0 0 2px var(--focus)}button:active,input[type=button]:active,input[type=checkbox]:active,input[type=radio]:active,input[type=range]:active,input[type=reset]:active,input[type=submit]:active{transform:translateY(2px)}button:disabled,input:disabled,select:disabled,textarea:disabled{cursor:not-allowed;opacity:.5}::-moz-placeholder{color:#949494;color:var(--form-placeholder)}:-ms-input-placeholder{color:#949494;color:var(--form-placeholder)}::-ms-input-placeholder{color:#949494;color:var(--form-placeholder)}::placeholder{color:#949494;color:var(--form-placeholder)}fieldset{border:1px solid #0096bfab;border:1px var(--focus) solid;border-radius:6px;margin:0 0 12px;padding:10px}legend{font-size:.9em}input[type=range]{margin:10px 0;padding:10px 0;background:0 0}input[type=range]::-webkit-slider-runnable-track{width:100%;height:9.5px;-webkit-transition:.2s;transition:.2s;background:#efefef;background:var(--background);border-radius:3px}input[type=range]::-webkit-slider-thumb{box-shadow:0 1px 1px #000,0 0 1px #0d0d0d;height:20px;width:20px;border-radius:50%;background:#dbdbdb;background:var(--border);-webkit-appearance:none;margin-top:-7px}input[type=range]:focus::-webkit-slider-runnable-track{background:#efefef;background:var(--background)}input[type=range]::-moz-range-track{width:100%;height:9.5px;-moz-transition:.2s;transition:.2s;background:#efefef;background:var(--background);border-radius:3px}input[type=range]::-moz-range-thumb{box-shadow:1px 1px 1px #000,0 0 1px #0d0d0d;height:20px;width:20px;border-radius:50%;background:#dbdbdb;background:var(--border)}input[type=range]::-ms-track{width:100%;height:9.5px;background:0 0;border-color:transparent;border-width:16px 0;color:transparent}input[type=range]::-ms-fill-lower{background:#efefef;background:var(--background);border:.2px solid #010101;border-radius:3px;box-shadow:1px 1px 1px #000,0 0 1px #0d0d0d}input[type=range]::-ms-fill-upper{background:#efefef;background:var(--background);border:.2px solid #010101;border-radius:3px;box-shadow:1px 1px 1px #000,0 0 1px #0d0d0d}input[type=range]::-ms-thumb{box-shadow:1px 1px 1px #000,0 0 1px #0d0d0d;border:1px solid #000;height:20px;width:20px;border-radius:50%;background:#dbdbdb;background:var(--border)}input[type=range]:focus::-ms-fill-lower{background:#efefef;background:var(--background)}input[type=range]:focus::-ms-fill-upper{background:#efefef;background:var(--background)}a{text-decoration:none;color:#0076d1;color:var(--links)}a:hover,summary:focus,summary:hover{text-decoration:underline}code,samp,time{background:var(--background);color:#000;color:var(--code);padding:2.5px 5px;border-radius:6px;font-size:1em}pre>code{padding:10px;display:block;overflow-x:auto}var{color:#39a33c;color:var(--variable);font-family:monospace}kbd{background:var(--background);border:1px solid #dbdbdb;border:1px solid var(--border);border-radius:2px;color:var(--text-main);padding:2px 4px}img,video{max-width:100%;height:auto}hr{border:none;border-top:1px solid #dbdbdb;border-top:1px solid var(--border)}table{border-collapse:collapse;table-layout:fixed}td,th{padding:6px}thead{border-bottom:1px solid #dbdbdb;border-bottom:1px solid var(--border)}tfoot{border-top:1px solid #dbdbdb;border-top:1px solid var(--border)}tbody tr:nth-child(2n){background-color:#efefef;background-color:var(--background)}tbody tr:nth-child(2n) button{background-color:#f7f7f7;background-color:var(--background-alt)}tbody tr:nth-child(2n) button:hover{background-color:#fff;background-color:var(--background-body)}::-webkit-scrollbar{height:10px;width:10px}::-webkit-scrollbar-track{background:#efefef;background:var(--background);border-radius:6px}::-webkit-scrollbar-thumb{background:#aaa;background:var(--scrollbar-thumb);border-radius:6px}::-webkit-scrollbar-thumb:hover{background:#9b9b9b;background:var(--scrollbar-thumb-hover)}::-moz-selection{background-color:#9e9e9e;background-color:var(--selection);color:#000;color:var(--text-bright)}::selection{background-color:#9e9e9e;background-color:var(--selection);color:#000;color:var(--text-bright)}details{display:flex;flex-direction:column;align-items:flex-start;background-color:var(--background-alt);padding:10px 10px 0;margin:1em 0;border-radius:6px;overflow:hidden}details[open],summary{padding:10px}details>:last-child{margin-bottom:0}summary{display:list-item;background-color:#efefef;background-color:var(--background);margin:-10px -10px 0}details>:not(summary){margin-top:0}summary::-webkit-details-marker{color:#363636;color:var(--text-main)}dialog{background-color:var(--background-alt);color:var(--text-main);border:#dbdbdb;border-radius:6px;border-color:var(--border);padding:10px 30px}dialog>header:first-child{background-color:#efefef;background-color:var(--background);border-radius:6px 6px 0 0;margin:-10px -30px 10px;padding:10px;text-align:center}dialog::-webkit-backdrop{background:#0000009c;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}dialog::backdrop{background:#0000009c;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}footer{border-top:1px solid #dbdbdb;border-top:1px solid var(--border);padding-top:10px;color:#70777f;color:var(--text-muted)}body>footer{margin-top:40px}@media print{body,button,code,details,input,pre,summary,textarea{background-color:#fff}button,input,textarea{border:1px solid #000}body,button,code,footer,h1,h2,h3,h4,h5,h6,input,pre,strong,summary,textarea{color:#000}summary::marker{color:#000}summary::-webkit-details-marker{color:#000}tbody tr:nth-child(2n){background-color:#f2f2f2}a{color:#00f;text-decoration:underline}}`;

    var fileDownload = require('js-file-download');
    fileDownload(finalCSS, 'cssMIN.css');
  }

  const [backgroundBody, setBackgroundBody] = useState('#fff');
  function setBackgroundBodyColor(color) {
    setBackgroundBody(color.hex);
    document.documentElement.style.setProperty('--background-body', color.hex);
  }
  
  const [background, setBackground] = useState('#efefef');
  function setBackgroundColor(color) {
    setBackground(color.hex);
    document.documentElement.style.setProperty('--background', color.hex);
  }

  const [selection, setSelection] = useState('#9e9e9e');
  function setSelectionColor(color) {
    setSelection(color.hex);
    document.documentElement.style.setProperty('--selection', color.hex);
  }

  const [textMain, setTextMain] = useState('#363636');
  function setTextMainColor(color) {
    setTextMain(color.hex);
    document.documentElement.style.setProperty('--text-main', color.hex);
  }

  const [textBright, setTextBright] = useState('#000');
  function setTextBrightColor(color) {
    setTextBright(color.hex);
    document.documentElement.style.setProperty('--text-bright', color.hex);
  }

  const [textForm, setTextForm] = useState('#1d1d1d');
  function setTextFormColor(color) {
    setTextForm(color.hex);
    document.documentElement.style.setProperty('--form-text', color.hex);
  }

  const [link, setLink] = useState('#0076d1');
  function setLinkColor(color) {
    setLink(color.hex);
    document.documentElement.style.setProperty('--links', color.hex);
  }

  const [focus, setFocus] = useState('#0096bfab');
  function setFocusColor(color) {
    setFocus(color.hex);
    document.documentElement.style.setProperty('--focus', color.hex);
  }

  const [border, setBorder] = useState('#dbdbdb');
  function setBorderColor(color) {
    setBorder(color.hex);
    document.documentElement.style.setProperty('--border', color.hex);
  }

  const [button, setButton] = useState('#d0cfcf');
  function setButtonColor(color) {
    setButton(color.hex);
    document.documentElement.style.setProperty('--button-base', color.hex);
  }

  const [buttonHover, setButtonHover] = useState('#9b9b9b');
  function setButtonHoverColor(color) {
    setButtonHover(color.hex);
    document.documentElement.style.setProperty('--button-hover', color.hex);
  }

  const [scrollbar, setScrollbar] = useState('rgb(170, 170, 170)');
  function setScrollbarColor(color) {
    setScrollbar(color.hex);
    document.documentElement.style.setProperty('--scrollbar-thumb', color.hex);
  }

  function setSample1() {
    setBackgroundBodyColor({ hex: '#000127' });
    setBackgroundColor({ hex: '#efefef' });
    setSelectionColor({ hex: '#FFFFFF' });
    setTextMainColor({ hex: '#ffffff' });
    setTextBrightColor({ hex: '#ffffff' });
    setLinkColor({ hex: '#13a0ff' });
    setFocusColor({ hex: '#3738ca' });
    setBorderColor({ hex: '#cf8c8c' });
    setButtonColor({ hex: '#c9dbf1' });
    setButtonHoverColor({ hex: '#7fbde5' });
    setScrollbarColor({ hex: '#a9e4f5' });
    setTextFormColor({ hex: '#180202' });
  }

  function setSample2() {
    setBackgroundBodyColor({ hex: '#e0ffec' });
    setBackgroundColor({ hex: '#c3f5ae' });
    setSelectionColor({ hex: '#c2ffb1' });
    setTextMainColor({ hex: '#363636' });
    setTextBrightColor({ hex: '#000' });
    setLinkColor({ hex: '#40c800' });
    setFocusColor({ hex: '#e54040' });
    setBorderColor({ hex: '#dbdbdb' });
    setButtonColor({ hex: '#9af19a' });
    setButtonHoverColor({ hex: '#55ef4d' });
    setScrollbarColor({ hex: '#699d2e' });
    setTextFormColor({ hex: '#1d1d1d' });
  }

  return (
    <>
      <h1>Drop-In CSS Generator</h1>
      <p>If you're making a simple website and want to add some styling to it quickly, use this tool to generate custom classless CSS style sheets based on <a href='https://watercss.kognise.dev' target='_blank' rel='noreferrer'>Water.css</a>. Clicking the "Download CSS" button will download a minified CSS file with your chosen color scheme to drop into any website. Use this page as a reference for how your site will look (font, layout, color scheme, etc.).</p>
      <p>Notes: refreshing the page will reset all values.</p>
      <div style={{ display: "flex" }}>
        <button onClick={generateFinalCSS} style={{ backgroundColor: "lightBlue", color: "black" }}>Download CSS</button>
        <button onClick={setSample1}>Sample Color Scheme 1</button>
        <button onClick={setSample2}>Sample Color Scheme 2</button>
      </div>
      <br />
      <br />
      <hr />
      <br />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))" }}>
        <div style={{ padding: "1em" }}>
          <h3>Body Background Color</h3>
          <p style={{ paddingBottom: "1em" }}>The background color of the entire page</p>
          <ChromePicker 
            color={backgroundBody}
            onChange={setBackgroundBodyColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Element Background Color</h3>
          <p style={{ paddingBottom: "1em" }}>
            <code>The background color of individual elements</code>
          </p>
          <ChromePicker 
            color={background}
            onChange={setBackgroundColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Selection Color</h3>
          <p style={{ paddingBottom: "1em" }}>The color of your selections (try selecting this text)</p>
          <ChromePicker 
            color={selection}
            onChange={setSelectionColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Primary Text Color</h3>
          <p style={{ paddingBottom: "1em" }}>The primary color of text</p>
          <ChromePicker 
            color={textMain}
            onChange={setTextMainColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Heading/Bold Text Color</h3>
          <p style={{ paddingBottom: "1em" }}>The color of headers/bold text</p>
          <ChromePicker 
            color={textBright}
            onChange={setTextBrightColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Form/Button Text Color</h3>
          <button style={{ marginBottom: "1em" }} onClick={setSample1}>The color of form text</button>
          <ChromePicker 
            color={textForm}
            onChange={setTextFormColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Link Color</h3>
          <p style={{ paddingBottom: "1em" }}><a href='#'>The color of links</a></p>
          <ChromePicker 
            color={link}
            onChange={setLinkColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Focus Color</h3>
          <textarea value={"Click me"} style={{ maxHeight: "2em", marginBottom: "1em" }} />
          <ChromePicker 
            color={focus}
            onChange={setFocusColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Border Color</h3>
          <button style={{ border: "2px solid var(--border)", marginBottom: "1em" }}>The color of borders</button>
          <ChromePicker 
            color={border}
            onChange={setBorderColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Button Color</h3>
          <button style={{ marginBottom: "1em" }}>The color of buttons</button>
          <ChromePicker
            color={button}
            onChange={setButtonColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em" }}>
          <h3>Button Hover Color</h3>
          <button style={{ marginBottom: "1em" }}>Hover over me</button>
          <ChromePicker
            color={buttonHover}
            onChange={setButtonHoverColor}
            disableAlpha
          />
        </div>
        <div style={{ padding: "1em"}}>
          <h3>Scrollbar Color</h3>
          <p style={{ marginBottom: "1em" }}>The color of the scrollbar</p>
          <ChromePicker
            color={scrollbar}
            onChange={setScrollbarColor}
            disableAlpha
          />
        </div>
      </div>
      <br />
      <br />
      <hr />
      <br />
      <a href="https://www.producthunt.com/posts/drop-in-css-generator?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-drop&#0045;in&#0045;css&#0045;generator" target="_blank" rel='noreferrer'><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=395743&theme=light" alt="Drop&#0045;In&#0032;CSS&#0032;Generator - Generate&#0032;custom&#0032;style&#0032;sheets&#0032;for&#0032;simple&#0032;websites | Product Hunt" style={{ width: "250px", height: "54px" }} width="250" height="54" /></a>
      <p>Made by <a href='https://rtaneja.com' target='_blank' rel='noreferrer'>Rohan Taneja</a></p>
      <br />
    </>
  );
}

export default App;
